"use client";

import { useEffect } from "react";

import { API_BASE_URL } from "@lib/config";
import { getSearchContext } from "@lib/search/session";
import { getClientAuthHeaders } from "@lib/auth/client-token";

type ProductVisitTrackerProps = {
  productId?: string | null;
};

export default function ProductVisitTracker({ productId }: ProductVisitTrackerProps) {
  useEffect(() => {
    if (!productId) return;

    const controller = new AbortController();

    const recordVisit = async () => {
      try {
        const referer = typeof document !== "undefined" ? document.referrer : undefined;
        const { sessionId, userToken } = getSearchContext();
        await fetch(`${API_BASE_URL}/public/analytics/products/visit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...getClientAuthHeaders(),
          },
          body: JSON.stringify({
            productId,
            referer,
            sessionId: sessionId || undefined,
            userToken: userToken || undefined,
          }),
          keepalive: true,
          signal: controller.signal,
        });
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("Failed to record product visit", error);
        }
      }
    };

    recordVisit();

    return () => {
      controller.abort();
    };
  }, [productId]);

  return null;
}
